import Dialog from "../ui-control/Dialog";
import XButton from "../common/XButton";
import { useDemandStudioContext } from "../../contexts/DemandStudioContext";

const titleRowClasses = "flex justify-center mt-8";
const messageRowClasses = "flex justify-center mt-4 px-8 text-center";
const actionsRowClasses = "flex justify-center mt-6";
const spinnerClasses =
  "animate-spin h-8 w-8 border-[0.25em] border-primary border-t-transparent rounded-full m-3";

const DemandStudioRestoreAllModal = () => {
  const {
    isWipeAllModalOpen,
    confirmWipeAll,
    cancelWipeAll,
    isWipeAllLoading,
  } = useDemandStudioContext();

  if (!isWipeAllModalOpen) return null;

  return (
    <Dialog
      isModalOpen={isWipeAllModalOpen}
      onToggleDialog={(isDialogOpen) => {
        if (!isDialogOpen) cancelWipeAll();
      }}
      mode="small-half"
      isCloseIconHidden={false}
    >
      <div className={titleRowClasses}>
        <h3 className="title">Restore all sections to their original values?</h3>
      </div>
      <div className={messageRowClasses}>
        <p className="text-body">This will discard all suggested edits and revert every section to the first AI-generated version.</p>
      </div>
      <div className={actionsRowClasses}>
        {isWipeAllLoading ? (
          <div className={spinnerClasses} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          <XButton onClick={confirmWipeAll} className="min-w-24!">Yes</XButton>
        )}
        <XButton variant="outlinePrimary" onClick={cancelWipeAll} className="ml-4! min-w-24!">No</XButton>
      </div>
    </Dialog>
  );
};

export default DemandStudioRestoreAllModal;
